const PageError = () => {
    return (
        <div className='page-content'>
            <h1>Page not found</h1>
        </div>
    )
}

export default PageError